import React, { useState } from 'react';
import axios from "axios";
import { API_BASE_URL } from '../config';
import styles from './Contact.module.css';

export const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const { firstName, lastName, email, phone, message } = formData;

  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted!");
    try {
      const response = await axios.post(`${API_BASE_URL}/api/query`, 
      {
        fullName: `${firstName} ${lastName}`,
        email,
        phone,
        message,
      });
      setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);

      if (response.status === 200) {
        console.log("Query submitted successfully!");
        
        setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: ""
        })
        // tostershow();
      } else {
        console.error("Failed to submit query.");
      }

      console.log('formdata values', formData);
    } catch (error) {
      console.error("Error submitting query:", error);
    }

    
    
  };

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className="container">
          <h1 className="section-title" style={{ textAlign: 'center' }}>
            Reach Out To Us By <span style={{ color: 'var(--black)' }}>Filling This Form</span>
          </h1>
        </div>
      </section>

      <section className={styles.body}>
        <div className="container">
          <div className={styles.grid}>

            {/* Form */}
            <div className={styles.formWrap}>
              {showSuccess ? (
                <div className={styles.success}>
                  <span className={styles.successIcon}>âœ“</span>
                  <h3>Message Received!</h3>
                  <p>Thank you for reaching out. Our team will get back to you within 24 hours.</p>
                  <button className="btn btn-red" onClick={() => setShowSuccess(false)}>Send another</button>
                </div>
              ) : (
                <form className={styles.form} onSubmit={handleOnSubmit}>
                  <div className={styles.row}>
                    <div className={styles.field}>
                      <label>First Name</label>
                      <input
                        name="firstName"
                        value={firstName}
                        onChange={handleOnChange}
                        placeholder="First Name"
                        required
                      />
                    </div>
                    <div className={styles.field}>
                      <label>Last Name</label>
                      <input
                        name="lastName"
                        value={lastName}
                        onChange={handleOnChange}
                        placeholder="Last Name"
                        required
                      />
                    </div>
                  </div>
                  <div className={styles.field}>
                    <label>Email</label>
                    <input
                      name="email"
                      type="email"
                      value={email}
                      onChange={handleOnChange}
                      placeholder="john@example.com"
                      required
                    />
                  </div>
                  <div className={styles.field}>
                    <label>Phone Number</label>
                    <input
                      name="phone"
                      type="tel"
                      value={phone}
                      onChange={handleOnChange}
                      placeholder="+91 ()"
                      required
                    />
                  </div>
                  <div className={styles.field}>
                    <label>Queries</label>
                    <textarea
                      name="message"
                      value={message}
                      onChange={handleOnChange}
                      placeholder="Tell us about your project"
                      rows={5}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-red" style={{ width: '100%', justifyContent: 'center' }}>
                    Send Message
                  </button>
                </form>
              )}
            </div>

            {/* Map Placeholder */}
            <div className={styles.mapWrap}>
              <div className={styles.mapContainer}>
                <iframe
                title="TSIL Office Location"
                src="https://maps.google.com/maps?q=609%20Tower%20II%20Pearls%20Omaxe%20NSP%20Pitampura%20New%20Delhi%20110034&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                />
              </div>

              <div className={styles.info}>
                <div className={styles.infoItem}>
                  <strong>Email</strong>
                  <span>team@tsil.net.in</span>
                </div>
                <div className={styles.infoItem}>
                  <strong>Phone</strong>
                  <span>+91-96618 29944</span>
                </div>
                <div className={styles.infoItem}>
                  <strong>Office</strong>
                  <span>609, Tower II, Pearls Omaxe, NSP, Pitampura, New Delhi - 110034</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}
//25/05
export default Contact;
